module.exports = __webpack_public_path__ + "static/img/banber (2).76970c7b.png";